import React, { useState } from "react";

import { formatNumber } from "../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

import { RequiredText } from "../../RequiredText";
import { AddPricingTierModal } from "./AddPricingTierModal";
import { PricingTier } from "./PricingTier";
import { DeleteModal } from "../../DeleteModal";

export default function Inventory({
  eventPackage,
  inventory,
  pricingTiers,
  setPricingTiers,
  requiredFieldErrorStatus,
  isDisabled,
}) {
  const [show, setShow] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  // for editing
  const [pricingTier, setPricingTier] = useState();

  // id to remove
  const [id, setId] = useState();

  const getText = () => {
    const numSeats = inventory?.seats?.length;
    return `${numSeats > 0 ? `${formatNumber(numSeats)} ${numSeats === 1 ? "seat" : "seats"}` : "No seats assigned"}`;
  };

  const handleShow = (_, id) => {
    setShow(true);
    setPricingTier(pricingTiers[id]);
  };

  const handleClose = () => {
    setShow(false);
    setPricingTier();
  };

  const handleAdd = (tier) => {
    // editing
    if (pricingTier) {
      setPricingTiers((prevState) => ({
        ...prevState,
        [tier?.id]: {
          ...tier?.id,
          ...tier,
        },
      }));
    }
    // create new
    else {
      const generateKey = (obj) => {
        const keys = Object.keys(obj);
        if (keys.length === 0) {
          return keys.length + 1;
        } else {
          // Get the highest existing key and add 1 to get the next key - so keys don't get messed up after deleting
          return Math.max(...keys) + 1;
        }
      };
      let id = generateKey(pricingTiers);
      console.log(id);
      setPricingTiers((prevState) => ({
        ...prevState,
        [id]: {
          id,
          ...tier,
        },
      }));
    }
    handleClose();
  };

  const handleShowDelete = (id) => {
    setShowDelete(true);
    setId(Number(id));
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
    setId();
  };

  const handleDelete = () => {
    const updatedPricingTiers = { ...pricingTiers };
    delete updatedPricingTiers[id];
    setPricingTiers(updatedPricingTiers);
    handleCloseDelete();
  };

  return (
    <>
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">Inventory</Card.Title>
      </div>
      <Stack gap={4}>
        <Card body className="card--sm card-with-border">
          <Stack direction="horizontal" className="heading--flex-space-between">
            <Stack direction="horizontal" className="flex-sm">
              <div
                className="dot align-self-start"
                style={{
                  backgroundColor: inventory?.color,
                }}
              ></div>
              <Stack>
                <span className="item-name">{`${eventPackage?.name || "(Name needs to be assigned)"}`}</span>
                <span className="subtitle">{getText()}</span>
              </Stack>
            </Stack>
          </Stack>
        </Card>
        <div>
          <div className="card-body-heading card-body-heading--xs">
            <div>
              <div className="flex flex-sm">
                <Card.Title as="h5">Pricing Tiers</Card.Title>
                {requiredFieldErrorStatus?.pricingTiers && <RequiredText />}
              </div>
              <Card.Subtitle as="h6">
                Create pricing tier templates to streamline ticket assignments
                for fans or organizations. The pricing is applicable for each
                individual ticket.
              </Card.Subtitle>
            </div>
          </div>
          {pricingTiers && Object.values(pricingTiers)?.length > 0 && (
            <Stack as="ul" gap={3} className="mb-3">
              {Object.values(pricingTiers)?.map((pricingTier) => (
                <PricingTier
                  key={pricingTier?.id}
                  pricingTier={pricingTier}
                  handleShow={handleShow}
                  confirmRemoval={handleShowDelete}
                />
              ))}
            </Stack>
          )}
          <Button
            size="sm"
            variant="outline-light"
            className={`btn-plus ${requiredFieldErrorStatus?.pricingTiers ? "error-border" : ""}`}
            onClick={handleShow}
            disabled={isDisabled}
          >
            Add tier
          </Button>
        </div>
      </Stack>

      <AddPricingTierModal
        show={show}
        pricingTier={pricingTier}
        handleAdd={handleAdd}
        handleClose={handleClose}
        confirmRemoval={handleShowDelete}
      />

      <DeleteModal
        entity="pricing tier"
        show={showDelete}
        handleDelete={handleDelete}
        handleClose={handleCloseDelete}
      />
    </>
  );
}
